var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Horizontal',{staticClass:"button-group",class:{stretch: _vm.stretch, combined: _vm.combined},attrs:{"align":_vm.align,"reverse":_vm.reverse}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }